import bindAll from "lodash/bindAll";
import isFunction from "lodash/isFunction";

export default class AnimationFrameHander {
    constructor() {
        bindAll(this, `animate`);
    }

    /**
     * @method
     * @summary - Queue logic to be executed as part of the RAF loop
     *
     * @param {Function} cb The logic to be executed during a frame
     */
    animate(cb) {
        if (!isFunction(cb)) {
            throw new TypeError(
                `AnimationFrameHander animate() - first argument is not a function`
            );
        }
        if (this.animationFrameId) {
            window.cancelAnimationFrame(this.animationFrameId);
        }
        this.animationFrameId = window.requestAnimationFrame(cb);
    }
}
